/**
 * File generated by js-routes 2.0.7
 * Based on Rails 6.1.3.1 routes of Agro2business::Application
 */
const __jsr = ((that) => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const Root = that;
    const ModuleReferences = {
        CJS: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            define: (routes) => (module.exports = routes),
            support: () => typeof module === "object",
        },
        AMD: {
            define: (routes) => 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            define([], function () {
                return routes;
            }),
            support: () => typeof define === "function" && !!define.amd,
        },
        UMD: {
            define: (routes) => {
                if (ModuleReferences.AMD.support()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.support()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            support: () => ModuleReferences.AMD.support() || ModuleReferences.CJS.support(),
        },
        ESM: {
            define: () => null,
            support: () => true,
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const DeprecatedGlobbingBehavior = false;
    const UriEncoderSegmentRegex = /[^a-zA-Z0-9\-._~!$&'()*+,;=:@]/g;
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !object[this.configuration.special_options_key] &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) || result === false ? "" : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {};
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            const query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters, } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            return segment.replace(UriEncoderSegmentRegex, function (str) {
                return encodeURIComponent(str);
            });
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return "(" + this.build_path_spec(route[1]) + ")";
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return DeprecatedGlobbingBehavior ? result : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        has_location() {
            return this.is_not_nullable(window) && !!window.location;
        }
        current_host() {
            if (this.has_location()) {
                return window.location.hostname;
            }
            else {
                return null;
            }
        }
        current_protocol() {
            if (this.has_location() && window.location.protocol !== "") {
                return window.location.protocol.replace(/:$/, "");
            }
            else {
                return "http";
            }
        }
        current_port() {
            if (this.has_location() && window.location.port !== "") {
                return window.location.port;
            }
            else {
                return "";
            }
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        namespace(object, namespace, routes) {
            const parts = (namespace === null || namespace === void 0 ? void 0 : namespace.split(".")) || [];
            if (parts.length === 0) {
                return routes;
            }
            for (let index = 0; index < parts.length; index++) {
                const part = parts[index];
                if (index < parts.length - 1) {
                    object = object[part] || (object[part] = {});
                }
                else {
                    return (object[part] = routes);
                }
            }
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].support();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            if (!name) {
                return;
            }
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.namespace(Root, null, result);
    if ("ESM") {
        Utils.define_module("ESM", result);
    }
    return result;
})(this);
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /abra_partnership(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abra_partnership_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"abra_partnership"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /parceria-abra(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abra_partnership_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"parceria-abra"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /addresses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const address_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enderecos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const address_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enderecos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /addresses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addresses_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /enderecos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addresses_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"enderecos"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/abra_solicitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_abra_solicitation_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abra_solicitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/abra_solicitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_abra_solicitations_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"abra_solicitations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_announcement_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_announcements_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/banks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bank_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bank_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bank_account_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bank_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bank_accounts_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bank_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/banks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_banks_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_insert_spreadsheets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bulk_insert_spreadsheet_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_insert_spreadsheets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_insert_spreadsheets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bulk_insert_spreadsheets_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_insert_spreadsheets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_developer_applies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_business_developer_applies_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_developer_applies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_developer_applies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_business_developer_apply_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_developer_applies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_developer_transactions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_business_developer_transaction_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_developer_transactions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_developer_transactions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_business_developer_transactions_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_developer_transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/buy_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_buy_requests_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"buy_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_categories_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_category_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_comment_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_comments_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_document_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/document_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_document_categories_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"document_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/document_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_document_category_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"document_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_documents_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/hooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_hook_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/hooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_hooks_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_invoice_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_invoices_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_job_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_jobs_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/notifications/sales/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_notifications_sale_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/notifications/sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_notifications_sales_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_seo_configurations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_page_seo_configuration_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_seo_configurations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_seo_configurations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_page_seo_configurations_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_seo_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/payments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_payment_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_payments_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/permissions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_permission_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_permissions_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_post_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_posts_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_search_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_product_search_logs_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_search_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_question_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_questions_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"questions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_role_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_roles_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sale_evaluations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_evaluation_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sale_evaluations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sale_evaluations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_evaluations_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sale_evaluations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sale_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_item_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sale_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sale_items/:sale_item_id/approve(.:format)
 * @param {any} sale_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_item_approve_path = __jsr.r({"sale_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sale_items"],[2,[7,"/"],[2,[3,"sale_item_id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sales_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_subscriber_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_subscribers_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/masquerade(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_masquerade_path = __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"masquerade"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/update_role(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_update_role_path = __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"update_role"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agronews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agronews_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agronews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agronews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agronews_index_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agronews"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agronews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agronews_index_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agronews"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agronews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agronews_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agronews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /animal_nutrition(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const animal_nutrition_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"animal_nutrition"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /nutricao-animal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const animal_nutrition_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"nutricao-animal"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /animal_nutrition_tips(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const animal_nutrition_tips_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"animal_nutrition_tips"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /nutricao-animal-conceitos-tecnicas-dicas-e-contexto(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const animal_nutrition_tips_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"nutricao-animal-conceitos-tecnicas-dicas-e-contexto"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/build/:id(.:format)
 * @param {any} announcement_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_build_en_path = __jsr.r({"announcement_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/build(.:format)
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_build_index_en_path = __jsr.r({"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"build"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/build(.:format)
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_build_index_pt_br_path = __jsr.r({"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"build"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/build/:id(.:format)
 * @param {any} announcement_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_build_pt_br_path = __jsr.r({"announcement_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"build"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/documents/:id(.:format)
 * @param {any} announcement_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_document_en_path = __jsr.r({"announcement_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/documentos/:id(.:format)
 * @param {any} announcement_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_document_pt_br_path = __jsr.r({"announcement_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"documentos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/documents(.:format)
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_documents_en_path = __jsr.r({"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/documentos(.:format)
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_documents_pt_br_path = __jsr.r({"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"documentos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/dupe(.:format)
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_dupe_en_path = __jsr.r({"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"dupe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/dupe(.:format)
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_dupe_pt_br_path = __jsr.r({"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"dupe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/images/:id(.:format)
 * @param {any} announcement_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_image_en_path = __jsr.r({"announcement_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/images/:id(.:format)
 * @param {any} announcement_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_image_pt_br_path = __jsr.r({"announcement_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/images(.:format)
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_images_en_path = __jsr.r({"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/images(.:format)
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_images_pt_br_path = __jsr.r({"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcement_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_list_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcement_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcement_lists/:announcement_list_id/announcement_list_items(.:format)
 * @param {any} announcement_list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_list_announcement_list_items_path = __jsr.r({"announcement_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcement_lists"],[2,[7,"/"],[2,[3,"announcement_list_id"],[2,[7,"/"],[2,[6,"announcement_list_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcement_list_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_list_item_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcement_list_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcement_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_lists_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcement_lists"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /announcements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/toggle_pause(.:format)
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_toggle_pause_en_path = __jsr.r({"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"toggle_pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/toggle_pause(.:format)
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_toggle_pause_pt_br_path = __jsr.r({"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"toggle_pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcements_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcements_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /questions/:id/answer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const answer_question_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"answer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /perguntas/:id/answer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const answer_question_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"perguntas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"answer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/addresses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_address_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/addresses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_addresses_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/announcements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_announcement_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_announcements_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_categories_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_login_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_questions_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_user_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/autocomplete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const autocomplete_announcements_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcements/autocomplete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const autocomplete_announcements_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bank_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bank_account_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bank_account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bank_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bank_account_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bank_account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /biofilica(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const biofilica_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"biofilica"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /biofilica(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const biofilica_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"biofilica"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /business_developer/applies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_applies_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_developer"],[2,[7,"/"],[2,[6,"applies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /desenvolvedor-de-negocios/applies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_applies_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"desenvolvedor-de-negocios"],[2,[7,"/"],[2,[6,"applies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_developer/applies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_apply_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_developer"],[2,[7,"/"],[2,[6,"applies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /desenvolvedor-de-negocios/applies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_apply_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"desenvolvedor-de-negocios"],[2,[7,"/"],[2,[6,"applies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business_developer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_developer"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /desenvolvedor-de-negocios(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"desenvolvedor-de-negocios"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /business_developer/ranking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_ranking_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_developer"],[2,[7,"/"],[2,[6,"ranking"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /desenvolvedor-de-negocios/ranking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_ranking_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"desenvolvedor-de-negocios"],[2,[7,"/"],[2,[6,"ranking"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_developer/transactions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_transactions_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_developer"],[2,[7,"/"],[2,[6,"transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /desenvolvedor-de-negocios/transactions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_transactions_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"desenvolvedor-de-negocios"],[2,[7,"/"],[2,[6,"transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_developer/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_user_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_developer"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /desenvolvedor-de-negocios/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_user_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"desenvolvedor-de-negocios"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /business_developer/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_users_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_developer"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /desenvolvedor-de-negocios/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developer_users_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"desenvolvedor-de-negocios"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_developers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developers_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_developers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /business_developers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const business_developers_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_developers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /buy_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buy_requests_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"buy_requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /buy_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buy_requests_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"buy_requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cart_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cart"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /carrinho-de-compras(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cart_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"carrinho-de-compras"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cart/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_cart_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /carrinho-de-compras/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_cart_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"carrinho-de-compras"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cities_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cities"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cities_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cities"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const city_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const city_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /coming_soon(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coming_soon_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"coming_soon"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /coming_soon(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coming_soon_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"coming_soon"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comments_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comments_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cart/complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_cart_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /carrinho-de-compras/complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_cart_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"carrinho-de-compras"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /contest/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_contest_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contest"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contest/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_contest_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contest"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /documentos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documentos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documents_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /documentos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documents_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"documentos"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /addresses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_address_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enderecos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_address_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enderecos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/banks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_bank_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_category_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/comments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_comment_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/document_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_document_category_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"document_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_seo_configurations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_page_seo_configuration_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_seo_configurations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/permissions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_permission_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/posts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_post_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_role_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_subscriber_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_announcement_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcement_lists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_announcement_list_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcement_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcement_list_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_announcement_list_item_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcement_list_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_announcement_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/:id/edit_avatar(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_avatar_api_v1_user_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bank_account/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bank_account_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bank_account"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bank_account/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bank_account_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bank_account"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_developer/applies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_business_developer_apply_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"business_developer"],[2,[7,"/"],[2,[6,"applies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /desenvolvedor-de-negocios/applies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_business_developer_apply_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"desenvolvedor-de-negocios"],[2,[7,"/"],[2,[6,"applies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cities/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_city_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cities/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_city_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_document_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /documentos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_document_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"documentos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_job_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_job_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketplace_account/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_marketplace_account_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketplace_account"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketplace_account/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_marketplace_account_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketplace_account"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/edit_position(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_position_admin_categories_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"edit_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcement_lists/edit_position(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_position_announcement_lists_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcement_lists"],[2,[7,"/"],[2,[6,"edit_position"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /questions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_question_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /perguntas/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_question_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"perguntas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rails_conductor_inbound_email_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /regions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_region_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /regioes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_region_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regioes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /registration/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_registration_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /registration/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_registration_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/bids/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_reverse_auction_bid_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"bids"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/ofertas/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_reverse_auction_bid_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"ofertas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/demands/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_reverse_auction_demand_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"demands"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/demandas/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_reverse_auction_demand_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"demandas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/purchase_orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_reverse_auction_purchase_order_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"purchase_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/ordens-de-compra/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_reverse_auction_purchase_order_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"ordens-de-compra"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /role_solicitations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_role_solicitation_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"role_solicitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /role_solicitations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_role_solicitation_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"role_solicitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /states/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_state_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /states/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_state_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/enviou_integration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enviou_integration_announcements_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"enviou_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcements/enviou_integration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enviou_integration_announcements_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"enviou_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /erp/bling/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const erp_bling_products_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"erp"],[2,[7,"/"],[2,[6,"bling"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /erp/bling/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const erp_bling_products_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"erp"],[2,[7,"/"],[2,[6,"bling"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /error(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const error_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"error"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /error(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const error_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"error"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /evaluate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluate_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"evaluate"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /evaluate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluate_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"evaluate"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /exporter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exporter_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exporter"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /seja-um-exportador-do-agronegocio(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exporter_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"seja-um-exportador-do-agronegocio"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /business_developer/users/find_by_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_by_code_business_developer_users_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_developer"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"find_by_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /desenvolvedor-de-negocios/users/find_by_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_by_code_business_developer_users_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"desenvolvedor-de-negocios"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"find_by_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcements/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_admin_announcements_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_announcements_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcements/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_announcements_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /investors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const investors_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"investors"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /investidores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const investors_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"investidores"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jobs_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jobs_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /landing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landing_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"landing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /landing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landing_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"landing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /leads/announcement_visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_announcement_visits_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"announcement_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads/announcement_visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_announcement_visits_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"announcement_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads/buy_intentions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_buy_intentions_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"buy_intentions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads/buy_intentions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_buy_intentions_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"buy_intentions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketplace_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketplace_account_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketplace_account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /marketplace_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketplace_account_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketplace_account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /marketplace/categories/:category_name(.:format)
 * @param {any} category_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketplace_category_en_path = __jsr.r({"category_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketplace"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketplace/categories/:category_name(.:format)
 * @param {any} category_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketplace_category_pt_br_path = __jsr.r({"category_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketplace"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /marketplace/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketplace_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketplace"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketplace(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketplace_index_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketplace"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /marketplace(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketplace_index_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketplace"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /marketplace/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketplace_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketplace"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /questions/:id/my_announcement(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_announcement_question_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"my_announcement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /perguntas/:id/my_announcement(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_announcement_question_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"perguntas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"my_announcement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /questions/my_announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_announcements_questions_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[6,"my_announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /perguntas/my_announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_announcements_questions_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"perguntas"],[2,[7,"/"],[2,[6,"my_announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /addresses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_address_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enderecos/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_address_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"enderecos"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/banks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_bank_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_category_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/comments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_comment_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/document_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_document_category_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"document_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/hooks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_hook_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_seo_configurations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_page_seo_configuration_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_seo_configurations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/permissions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_permission_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_post_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_role_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_subscriber_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/masquerade/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_user_masquerade_path = __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"masquerade"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_announcement_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcement_lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_announcement_list_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcement_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcement_lists/:announcement_list_id/announcement_list_items/new(.:format)
 * @param {any} announcement_list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_announcement_list_announcement_list_item_path = __jsr.r({"announcement_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcement_lists"],[2,[7,"/"],[2,[3,"announcement_list_id"],[2,[7,"/"],[2,[6,"announcement_list_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /announcements/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_announcement_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bank_account/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bank_account_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bank_account"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bank_account/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bank_account_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bank_account"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_developer/applies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_business_developer_apply_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_developer"],[2,[7,"/"],[2,[6,"applies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /desenvolvedor-de-negocios/applies/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_business_developer_apply_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"desenvolvedor-de-negocios"],[2,[7,"/"],[2,[6,"applies"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /buy_requests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_buy_request_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"buy_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /buy_requests/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_buy_request_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"buy_requests"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cities/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_city_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cities/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_city_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contest/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_contest_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contest"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contest/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_contest_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contest"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_document_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /documentos/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_document_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"documentos"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_job_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_job_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /questions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_question_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /perguntas/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_question_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"perguntas"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /regions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_region_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /regioes/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_region_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regioes"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /registration/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_registration_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /registration/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_registration_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/demands/:demand_id/payments/new(.:format)
 * @param {any} demand_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reverse_auction_demand_payment_en_path = __jsr.r({"demand_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"demands"],[2,[7,"/"],[2,[3,"demand_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/demandas/:demand_id/payments/novo(.:format)
 * @param {any} demand_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reverse_auction_demand_payment_pt_br_path = __jsr.r({"demand_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"demandas"],[2,[7,"/"],[2,[3,"demand_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/purchase_orders/:purchase_order_id/bids/new(.:format)
 * @param {any} purchase_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reverse_auction_purchase_order_bid_en_path = __jsr.r({"purchase_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"purchase_orders"],[2,[7,"/"],[2,[3,"purchase_order_id"],[2,[7,"/"],[2,[6,"bids"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/ordens-de-compra/:purchase_order_id/ofertas/novo(.:format)
 * @param {any} purchase_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reverse_auction_purchase_order_bid_pt_br_path = __jsr.r({"purchase_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"ordens-de-compra"],[2,[7,"/"],[2,[3,"purchase_order_id"],[2,[7,"/"],[2,[6,"ofertas"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/purchase_orders/:purchase_order_id/demands/new(.:format)
 * @param {any} purchase_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reverse_auction_purchase_order_demand_en_path = __jsr.r({"purchase_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"purchase_orders"],[2,[7,"/"],[2,[3,"purchase_order_id"],[2,[7,"/"],[2,[6,"demands"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/ordens-de-compra/:purchase_order_id/demandas/novo(.:format)
 * @param {any} purchase_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reverse_auction_purchase_order_demand_pt_br_path = __jsr.r({"purchase_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"ordens-de-compra"],[2,[7,"/"],[2,[3,"purchase_order_id"],[2,[7,"/"],[2,[6,"demandas"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/purchase_orders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reverse_auction_purchase_order_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"purchase_orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/ordens-de-compra/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reverse_auction_purchase_order_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"ordens-de-compra"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /role_solicitations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_role_solicitation_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"role_solicitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /role_solicitations/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_role_solicitation_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"role_solicitations"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_session_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_session_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /states/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_state_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /states/novo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_state_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[6,"novo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_payments_en_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_payments_pt_br_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_sales_en_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/vendas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_sales_pt_br_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"vendas"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /opportunities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opportunities_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"opportunities"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /oportunidades(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opportunities_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oportunidades"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /opportunities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opportunity_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oportunidades/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opportunity_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oportunidades"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/about_us(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_about_us_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"about_us"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pagina/about_us(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_about_us_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pagina"],[2,[7,"/"],[2,[6,"about_us"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/delivery_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_delivery_info_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"delivery_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pagina/delivery_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_delivery_info_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pagina"],[2,[7,"/"],[2,[6,"delivery_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/exchanges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_exchanges_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"exchanges"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pagina/exchanges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_exchanges_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pagina"],[2,[7,"/"],[2,[6,"exchanges"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/our_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_our_location_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"our_location"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pagina/our_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_our_location_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pagina"],[2,[7,"/"],[2,[6,"our_location"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/privacy_police(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_privacy_police_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"privacy_police"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pagina/privacy_police(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_privacy_police_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pagina"],[2,[7,"/"],[2,[6,"privacy_police"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/safety(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_safety_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"safety"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pagina/safety(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_safety_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pagina"],[2,[7,"/"],[2,[6,"safety"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/talk_to_us(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_talk_to_us_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"talk_to_us"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pagina/talk_to_us(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_talk_to_us_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pagina"],[2,[7,"/"],[2,[6,"talk_to_us"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_terms_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pagina/terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_terms_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pagina"],[2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/view_components/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_view_component_path = __jsr.r({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"view_components"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/view_components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_view_components_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"view_components"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_api_v1_users_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchase/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /purchase/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /purchases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchases_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /compras(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchases_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"compras"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const question_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /perguntas/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const question_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"perguntas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const questions_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"questions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /perguntas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const questions_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"perguntas"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_properties_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/routes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_routes_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/mailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailers_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /registration/recover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recover_registration_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"recover"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /registration/recover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recover_registration_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"recover"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /regions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const region_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /regioes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const region_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regioes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /regions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regions_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /regioes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regions_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regioes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registration_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registration_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /registration/reset_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_password_registration_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /registration/reset_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_password_registration_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/bids/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_bid_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"bids"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/ofertas/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_bid_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"ofertas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/dashboard/buyer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_dashboard_buyer_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"buyer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/dashboard/comprador(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_dashboard_buyer_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"comprador"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/dashboard/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_dashboard_home_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/dashboard/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_dashboard_home_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/dashboard/seller(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_dashboard_seller_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"seller"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/dashboard/vendedor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_dashboard_seller_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"vendedor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/demands/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_demand_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"demands"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/demands/:demand_id/payments(.:format)
 * @param {any} demand_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_demand_payments_en_path = __jsr.r({"demand_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"demands"],[2,[7,"/"],[2,[3,"demand_id"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/demandas/:demand_id/payments(.:format)
 * @param {any} demand_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_demand_payments_pt_br_path = __jsr.r({"demand_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"demandas"],[2,[7,"/"],[2,[3,"demand_id"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/demandas/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_demand_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"demandas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/payments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_payment_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/payments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_payment_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/purchase_orders/:purchase_order_id/bids(.:format)
 * @param {any} purchase_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_purchase_order_bids_en_path = __jsr.r({"purchase_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"purchase_orders"],[2,[7,"/"],[2,[3,"purchase_order_id"],[2,[7,"/"],[2,[6,"bids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/ordens-de-compra/:purchase_order_id/ofertas(.:format)
 * @param {any} purchase_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_purchase_order_bids_pt_br_path = __jsr.r({"purchase_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"ordens-de-compra"],[2,[7,"/"],[2,[3,"purchase_order_id"],[2,[7,"/"],[2,[6,"ofertas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/purchase_orders/:purchase_order_id/demands(.:format)
 * @param {any} purchase_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_purchase_order_demands_en_path = __jsr.r({"purchase_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"purchase_orders"],[2,[7,"/"],[2,[3,"purchase_order_id"],[2,[7,"/"],[2,[6,"demands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/ordens-de-compra/:purchase_order_id/demandas(.:format)
 * @param {any} purchase_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_purchase_order_demands_pt_br_path = __jsr.r({"purchase_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"ordens-de-compra"],[2,[7,"/"],[2,[3,"purchase_order_id"],[2,[7,"/"],[2,[6,"demandas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/purchase_orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_purchase_order_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"purchase_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/ordens-de-compra/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_purchase_order_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"ordens-de-compra"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/purchase_orders/:purchase_order_id/sales(.:format)
 * @param {any} purchase_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_purchase_order_sales_en_path = __jsr.r({"purchase_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"purchase_orders"],[2,[7,"/"],[2,[3,"purchase_order_id"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/ordens-de-compra/:purchase_order_id/vendas(.:format)
 * @param {any} purchase_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_purchase_order_sales_pt_br_path = __jsr.r({"purchase_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"ordens-de-compra"],[2,[7,"/"],[2,[3,"purchase_order_id"],[2,[7,"/"],[2,[6,"vendas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/purchase_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_purchase_orders_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"purchase_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/ordens-de-compra(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_purchase_orders_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"ordens-de-compra"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/sales/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_sale_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/vendas/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_sale_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"vendas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reverse_auction/sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_sales_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reverse_auction"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leilao-reverso/vendas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverse_auction_sales_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leilao-reverso"],[2,[7,"/"],[2,[6,"vendas"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /role_solicitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const role_solicitation_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"role_solicitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /role_solicitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const role_solicitation_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"role_solicitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /role_solicitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const role_solicitations_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"role_solicitations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /role_solicitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const role_solicitations_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"role_solicitations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /sale/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sale_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sale"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sale_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sale_item_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sale_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sale_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sale_item_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sale_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sale/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sale_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sale"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sales_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /vendas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sales_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendas"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /services(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const services_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"services"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /servicos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const services_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"servicos"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /addresses/:id/set_default(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_default_address_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enderecos/:id/set_default(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_default_address_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"enderecos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/addresses/:id/set_default(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_default_api_v1_address_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiq_web_path = __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]]);

/**
 * Generates rails route to
 * /business_developers/solicitation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const solicitation_business_developers_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_developers"],[2,[7,"/"],[2,[6,"solicitation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /business_developers/solicitation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const solicitation_business_developers_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"business_developers"],[2,[7,"/"],[2,[6,"solicitation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcements/spreadsheets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spreadsheets_announcements_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"spreadsheets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcements/spreadsheets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spreadsheets_announcements_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"spreadsheets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /states/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const state_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /states/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const state_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /states(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const states_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"states"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /states(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const states_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"states"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscribers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_en_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscribers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_pt_br_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscribers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribers_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscribers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribers_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/categories/update_position(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_position_admin_categories_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"update_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /announcement_lists/update_position(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_position_announcement_lists_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcement_lists"],[2,[7,"/"],[2,[6,"update_position"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/business_developer_applies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_business_developer_applies_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"business_developer_applies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/business_developer_applies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_business_developer_applies_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"business_developer_applies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/update_avatar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_update_avatar_en_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"update_avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/update_avatar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_update_avatar_pt_br_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"update_avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcements/:id/validate_address(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_address_admin_announcement_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate_address"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);